import { render, staticRenderFns } from "./AuthorizationForm.vue?vue&type=template&id=17e1b7c8&scoped=true&"
import script from "./AuthorizationForm.vue?vue&type=script&lang=js&"
export * from "./AuthorizationForm.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizationForm.vue?vue&type=style&index=0&id=17e1b7c8&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e1b7c8",
  null
  
)

export default component.exports